import React from 'react';
import { AURORA, lighten } from '../data/runTheme';

interface BreathOrbProps {
  scale: number;
  color: string;
  progress: number;
  label: string;
  count: number;
  showRing?: boolean;
}

const SIZE = 260;
const R = 120;
const CIRC = 2 * Math.PI * R;

const shadow = '0 2px 12px rgba(0,0,0,0.4)';

const BreathOrb: React.FC<BreathOrbProps> = ({ scale, color, progress, label, count, showRing = true }) => {
  const clamped = Math.max(0, Math.min(1, progress));
  return (
    <div style={{ position: 'relative', width: SIZE, height: SIZE, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {showRing && (
        <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`} style={{ position: 'absolute', inset: 0, transform: 'rotate(-90deg)' }}>
          <circle cx={SIZE / 2} cy={SIZE / 2} r={R} fill="none" stroke="#ffffff14" strokeWidth={3} />
          <circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={R}
            fill="none"
            stroke={color}
            strokeOpacity={0.55}
            strokeWidth={3}
            strokeLinecap="round"
            strokeDasharray={CIRC}
            strokeDashoffset={CIRC * (1 - clamped)}
            style={{ transition: 'stroke 1.2s ease' }}
          />
        </svg>
      )}
      <div
        style={{
          position: 'absolute',
          width: 150,
          height: 150,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${color}66, transparent 70%)`,
          transform: `scale(${scale})`,
          transition: 'background 1.2s ease',
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: `radial-gradient(circle at 34% 30%, ${lighten(color, 0.35)}, ${color})`,
          boxShadow: `0 0 48px ${color}80`,
          transform: `scale(${scale})`,
          transition: 'background 1.2s ease, box-shadow 1.2s ease',
        }}
      />
      <div style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <span style={{ fontSize: '1.5rem', fontWeight: 500, color: AURORA.textPrimary, textShadow: shadow }}>{label}</span>
        <span style={{ fontSize: '3.75rem', fontWeight: 300, lineHeight: 1, color: AURORA.textPrimary, fontVariantNumeric: 'tabular-nums', textShadow: shadow }}>{count}</span>
      </div>
    </div>
  );
};

export default BreathOrb;
